<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Vendedores</h4>
            <div class="small text-muted">Administración del legajo de cada vendedor</div>
          </b-col>

          <b-col sm="5">
            <b-button @click="add()" type="button" variant="primary" size="sm" class="btn-pill float-right ml-2" v-b-tooltip.hover title="Agregar Vendedor">
              <i class="fa fa-plus"></i> Agregar
            </b-button>

            <b-col sm="12" class="d-none d-md-block" v-if="!table.mostrarFiltros">
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" @click="table.mostrarFiltros=true" v-b-tooltip.hover title="Mostrar filtros">
                <i class="fa fa-filter"></i> Mostrar Filtros
              </b-button>
            </b-col>
            <b-col sm="12" class="d-none d-md-block" v-else>
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" v-if="table.mostrarFiltros" @click="table.mostrarFiltros=false" v-b-tooltip.hover title="Ocultar filtros">
                <i class="fa fa-window-close"></i>
              </b-button>
            </b-col>
          </b-col>             
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row v-if="table.mostrarFiltros">
          <b-col sm="4">
            <b-form-group>
              <b-input-group>
                <b-form-input type="text" size="sm" placeholder="Ingrese su busqueda" v-model="table.filter"></b-form-input>
                <b-input-group-prepend>
                  <b-button variant="dark" size="sm" :disabled="!table.filter" @click="table.filter = ''">
                    <i class="fa fa-filter"></i> Filtrar
                  </b-button>
                </b-input-group-prepend>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-table class="mb-0"
                    responsive="sm"
                    head-variant="dark"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"
                    :filter="table.filter"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    v-if="table.items.length">

                <template v-slot:cell(id)="data">
                  <b>{{ data.item.id }}</b>
                </template>               

                <template v-slot:cell(image)="data">
                  <b-avatar :src="data.item.staff.image"
                            v-if="data.item.staff.image">
                  </b-avatar>
                  <b-avatar v-else                  
                            variant="dark">
                  </b-avatar>                                  
                </template>

                <template v-slot:cell(zone)="data">                  
                  <div v-if="data.item.zones">
                    <b-badge  variant="secondary"
                              class="mr-2 sellers-badge-zone"
                              v-for="value in data.item.zones"
                              :key="value.id">
                              {{value.name}}
                    </b-badge>
                  </div>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right">    
                    <b-dropdown-item @click="irCalendar(data.item)">
                      <b-icon icon="calendar"></b-icon> Calendario
                    </b-dropdown-item>
                    <b-dropdown-item @click="irReports(data.item)" v-if="showReports">
                      <b-icon icon="file-text"></b-icon> Reportes
                    </b-dropdown-item>                           
                    <b-dropdown-header>Acciones</b-dropdown-header>                                                           
                    <b-dropdown-item @click="edit(data.item)">
                      <i class="fa fa-pencil ml-0 mr-0" style="color:blue"></i> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>                        
          </b-col>

          <b-col>
            <nav>
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="getRowCount(table.items)"
                            :per-page="table.perPage"
                            v-model="table.currentPage" />
            </nav>
          </b-col> 
        </b-row>
      </b-card>
      

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              header-bg-variant="dark"
              header-text-variant="white"
              :key="modal.form._id"
              :id="modal.form._id">                  
        <div slot="modal-header" minimize>
          {{this.modal.form.title}}
        </div>

        <b-row>
          <b-col md="12">
            <FindObject type="staff" 
                        @select-object="loadStaff($event)" 
                        :valueID="crud.form.staff_id"/>
          </b-col>

          <b-col md="12">
            <b-form-group label="Nombre">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.name"
                            required
                            placeholder="Ingresar un nombre">
              </b-form-input>
            </b-form-group>
          </b-col> 

          <b-col md="12">
            <b-form-group label="Teléfono">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.phone"
                            required
                            placeholder="Cod país [sin el signo] + nueve [9] + cod área [sin el 0] + nro cel [sin el 15] (total 13 dígitos)">
              </b-form-input>
            </b-form-group>
          </b-col> 

          <b-col md="12">
            <b-form-group label="Email">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.email"
                            required
                            placeholder="Ingresar un email">
              </b-form-input>
            </b-form-group>
          </b-col>                           
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()">Guardar</b-button>          
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject' 

  export default {
    components: {
      FindObject
    },    
    data: () => {
      return {      
        access: {
          module_id: Modules.VENDEDORES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudSellers',
          elements: {}
        }, 
        table : {
          items: [],
          fields: [
            {key: 'id', label: 'ID', sortable: true, class:"align-middle"},
            {key: 'image', label: 'Perfil', class:"align-middle"},
            {key: 'name', label: 'Nombre', class:"align-middle"},            
            {key: 'phone', label: 'Teléfono', class:"align-middle"},            
            {key: 'email', label: 'Email', class:"align-middle"},      
            {key: 'zone', label: 'Zonas', class:"align-middle"},            
            {key: 'f_action', label:'', class:"align-middle"},
          ],
          filter: null,
          mostrarFiltros: false,
          currentPage: 1,
          perPage: 50,
        },
        crud: {
          form: {
            id: 0,
            name: '',
            phone: '',
            email: '',
            staff: null,
            staff_id: 0,                       
          },          
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
        }                
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    }, 
    mounted() {
      this.load()
    },
    computed: {
      showReports() {
        var modulesActive = Session.getSession().auth.user.permissions.modules
        var status = false

        modulesActive.forEach(element => {
          if(element.id == Modules.INFORME_VISITAS ||
             element.id == Modules.INFORME_COBRANZAS ||
             element.id == Modules.INFORME_NOVEDADES ||
             element.id == Modules.INFORME_GENERAL) {
              status = true
          }             
        })        

        return status
      }
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      load() {
        var result = serviceAPI.obtenerVendedor()

        result.then((response) => {
          var data = response.data
          this.table.items = data
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });        
      },     
      loadStaff (object) {
        if(object){
          if(this.crud.form.staff_id != object.id) {
            this.crud.form.staff = object
            this.crud.form.staff_id = object.id
            this.crud.form.name = object.name
            this.crud.form.phone = object.phone
            this.crud.form.email = object.email
          }
        } else {
          this.crud.form.staff = null
          this.crud.form.staff_id = 0
          this.crud.form.name = ''
          this.crud.form.phone = ''
          this.crud.form.email = ''          
        }
      },            
      add() {
        this.crud.form.id = 0
        this.crud.form.name = ''    
        this.crud.form.staff_id = 0
        this.crud.form.staff = null
        this.crud.form.phone = ''
        this.crud.form.email = ''

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Vendedor"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name   
        this.crud.form.staff_id = item.staff.id   
        this.crud.form.staff = item.staff   
        this.crud.form.phone = item.phone
        this.crud.form.email = item.email

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Vendedor"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name        

        this.$bvModal.msgBoxConfirm('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Vendedor',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarVendedor(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        // valida que tenga el formato correcto para emails
        if(this.crud.form.email) {
          var expreg = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$")
          if (!expreg.test(this.crud.form.email)) {          
            this.$awn.alert("El email no posee un formato válido")          
            return false
          }       
        }

        // valida que tenga el formato para whatsapp
        if(this.crud.form.phone) {
          if(this.crud.form.phone.length < 9 || this.crud.form.phone.length > 20) {
            this.$awn.alert("El nro de télefono no posee un formato válido")
            return false
          }
        }

        let loader = this.$loading.show();
        if (this.crud.form.id) {
          var result = serviceAPI.editarVendedor(this.crud.form);
        } else {
          var result = serviceAPI.agregarVendedor(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      irCalendar(item) {
        this.$router.push({ name: 'SellersStaffSellersCalendar', params: {sellersID: item.id} })        
      },    
      irReports(item) {
        this.$router.push({ name: 'SellersStaffSellersReports', params: {sellersID: item.id} })        
      },    
    }     
  }
</script>
<style>
  .sellers-badge-zone {
    font-size: 13px;
  }
</style>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;    
  }  
</style>